<template>
  <div v-if="files.length > 0">
    <div
      class="download-row d-flex"
      v-for="f in filesByGroup[$route.params.groupId[5] - 1]"
      :key="f.name"
    >
      <div
        class="
          d-flex
          flex-column-reverse flex-md-row
          me-auto
          justify-content-end
        "
      >
        <div class="date me-2 small-text mobile-body">
          {{ formatDate(f.updated_at) }}
        </div>
        <div class="name small-text mobile-small fw-bold">
          <a
            :href="`//www.animlab.yuntech.edu.tw/upload/2021/download/${f.filename}`"
            :download="`${f.title}.${f.filename.split('.').pop()}`"
            >{{ f.title }}</a
          >
        </div>
      </div>
      <div class="link d-flex flex-center">
        <a
          :href="`//www.animlab.yuntech.edu.tw/upload/2021/download/${f.filename}`"
          :download="`${f.title}.${f.filename.split('.').pop()}`"
          ><img
            class="download d-none d-md-inline"
            :src="downloadIcon"
            :alt="f.name" /><img
            class="download d-md-none"
            :src="downloadIconV2"
            :alt="f.name"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import downloadIcon from '@/assets/img/download.png';
import downloadIconV2 from '@/assets/img/downloadv2.png';

// api
import { getDownloadFileList } from '@/api/download';

export default {
  name: 'Download',
  components: {
  },
  data() {
    return {
      downloadIcon,
      downloadIconV2,
      files: [],
    };
  },
  computed: {
    filesByGroup() {
      const rst = [[], [], []];
      this.files.forEach((ele) => {
        if (ele.group === 0) {
          rst[0].push(ele);
          rst[1].push(ele);
          rst[2].push(ele);
        } else rst[ele.group - 1].push(ele);
      });
      return rst;
    },
  },
  created() {
    const filter = { order: 'updated_at desc' };
    getDownloadFileList({ filter }).then((response) => {
      this.files = response;
    });
  },
  methods: {
    formatDate(dateString) {
      const date = dayjs(dateString);
      // Then specify how you want your dates to be formatted
      return date.format('YYYY/MM/DD');
    },
  },
};
</script>

<style lang="stylus" scoped>
img.download
  width: 24px;

.date
  color: $monoc2;

.name a
  &, &:hover, &:focus, &:active
    color: $monoc4;
    text-decoration: none;

.download-row
  padding: 4px;

  + .download-row
    border-top: 1px solid $monoc4;

@media screen and (max-width: 767.5px)
  .download-row
    padding: 0;

    + .download-row
      border-top: none;

      .flex-column-reverse
        border-top: 1px solid $monoc4;
        flex: 1;

  .link
    background: $monoc4;
    width: 80px;
    height: 80px;
    border-bottom: 1px solid $monoc2;

  .flex-column-reverse
    padding: 12px 0;
</style>
